import { commonColor } from '/@/utils/color'

// 작업 유형
export enum TaskType {
  Immediate = 0, // 즉시 실행
  Timed = 1, // 예약 실행
  Condition = 2, // 연속 실행
}

export const TaskTypeMap = {
  [TaskType.Immediate]: '즉시 실행',
  [TaskType.Timed]: '예약 실행',
  [TaskType.Condition]: '연속 실행',
}

export const TaskTypeOptions = [
  { value: TaskType.Immediate, label: TaskTypeMap[TaskType.Immediate] },
  { value: TaskType.Timed, label: TaskTypeMap[TaskType.Timed] },
  { value: TaskType.Condition, label: TaskTypeMap[TaskType.Condition] },
]

// 제어 불능 시 동작 (Failsafe)
export enum OutOfControlAction {
  ReturnToHome = 0, // 리턴 투 홈(RTH)
  Hover = 1, // 제자리 비행(Hover)
  Land = 2, // 착륙
}

export const OutOfControlActionMap = {
  [OutOfControlAction.ReturnToHome]: '리턴 투 홈(RTH)',
  [OutOfControlAction.Hover]: '제자리 비행(Hover)',
  [OutOfControlAction.Land]: '착륙',
}

export const OutOfControlActionOptions = [
  { value: OutOfControlAction.ReturnToHome, label: OutOfControlActionMap[OutOfControlAction.ReturnToHome] },
  { value: OutOfControlAction.Hover, label: OutOfControlActionMap[OutOfControlAction.Hover] },
  { value: OutOfControlAction.Land, label: OutOfControlActionMap[OutOfControlAction.Land] },
]

// 작업 상태
export enum TaskStatus {
  Wait = 1, // 대기 중
  Carrying = 2, // 실행 중
  Success = 3, // 완료
  CanCel = 4, // 취소됨
  Fail = 5, // 실패
  Paused = 6, // 일시 정지
}

export const TaskStatusMap = {
  [TaskStatus.Wait]: '대기 중',
  [TaskStatus.Carrying]: '실행 중',
  [TaskStatus.Success]: '작업 완료',
  [TaskStatus.CanCel]: '작업 취소됨',
  [TaskStatus.Fail]: '작업 실패',
  [TaskStatus.Paused]: '일시 정지됨',
}

export const TaskStatusColor = {
  [TaskStatus.Wait]: commonColor.BLUE,
  [TaskStatus.Carrying]: commonColor.BLUE,
  [TaskStatus.Success]: commonColor.NORMAL,
  [TaskStatus.CanCel]: commonColor.FAIL,
  [TaskStatus.Fail]: commonColor.FAIL,
  [TaskStatus.Paused]: commonColor.BLUE,
}

// 작업 실행 WS 메시지 상태
export enum TaskProgressStatus {
  Sent = 'sent', // 배포됨
  inProgress = 'in_progress', // 실행 중
  Paused = 'paused', // 일시 정지됨
  Rejected = 'rejected', // 거부됨
  Canceled = 'canceled', // 취소 또는 종료됨
  Timeout = 'timeout', // 시간 초과
  Failed = 'failed', // 실패
  OK = 'ok', // 성공
}

// 任务进度消息
export interface TaskProgressInfo {
  bid: string,
  output:{
    ext: {
      current_waypoint_index: number,
      media_count: number // 미디어 파일 수
    },
    progress:{
      current_step: number,
      percent: number
    },
    status: TaskProgressStatus
  },
  result: number,
}

// ws status => log status
export const TaskProgressWsStatusMap = {
  [TaskProgressStatus.Sent]: TaskStatus.Carrying,
  [TaskProgressStatus.inProgress]: TaskStatus.Carrying,
  [TaskProgressStatus.Rejected]: TaskStatus.Fail,
  [TaskProgressStatus.OK]: TaskStatus.Success,
  [TaskProgressStatus.Failed]: TaskStatus.Fail,
  [TaskProgressStatus.Canceled]: TaskStatus.CanCel,
  [TaskProgressStatus.Timeout]: TaskStatus.Fail,
  [TaskProgressStatus.Paused]: TaskStatus.Paused,
}

// 미디어 업로드 진행 상태
export enum MediaStatus { // 미디어 업로드 진행률
  ToUpload = 1, // 업로드 대기 중
  Uploading = 2, // 업로드 중
  Empty = 3, // 미디어 파일 없음
  Success = 4, // 업로드 성공
}

export const MediaStatusMap = {
  [MediaStatus.ToUpload]: '업로드 대기 중',
  [MediaStatus.Uploading]: '업로드 중...',
  [MediaStatus.Success]: '업로드 완료',
  [MediaStatus.Empty]: '미디어 파일 없음',
}

export const MediaStatusColorMap = {
  [MediaStatus.ToUpload]: commonColor.BLUE,
  [MediaStatus.Uploading]: commonColor.BLUE,
  [MediaStatus.Success]: commonColor.NORMAL,
  [MediaStatus.Empty]: commonColor.WARN,
}

// 媒体上传进度消息
export interface MediaStatusProgressInfo {
  job_id: string,
  media_count: number
  uploaded_count: number,
}

// 媒体上传优先级消息
export interface TaskMediaHighestPriorityProgressInfo {
  pre_job_id: string,
  job_id: string,
}
